<template>
  <CardContainer>
    <v-container>
      <v-layout row wrap>
        <v-flex xs12>
          <CardTitle>Reset Password</CardTitle>
        </v-flex>
      </v-layout>

      <form novalidate @submit.prevent="onSubmit">
        <v-layout row wrap>
          <v-flex xs12>
            <BaseAlert hg-type="error" :hg-value="hasApiError" @close="clearApiErrors">
              <p>Something went wrong while changing your password.
                Please check your inputs below and try again.</p>
              <p>If the problem continues, please visit
              <router-link to="/forgot-password">Forgot Password</router-link>
                to request a new password reset link.</p>
            </BaseAlert>

            <BaseAlert hg-type="error" :hg-value="formHasErrors" @close="clearFormErrors">
              <div v-for="error in errors.items" :key="error.id">
                {{error.msg}}
              </div>
            </BaseAlert>
          </v-flex>

          <v-flex xs12>
            <PasswordValidationField
              v-model="password"
              :validate="{ required: true }"
              autocomplete="new-password"
              data-vv-name="Password"
              label="Password"
              name="password"
              outline />
          </v-flex>

          <v-flex xs12>
            <PasswordField
              v-model="passwordConfirmation"
              v-validate="{...inputValidations.password, required: true, confirmed: password}"
              :enable-toggle="false"
              :error-messages="errors.collect('Confirm Password')"
              autocomplete="new-password"
              data-vv-name="Confirm Password"
              label="Confirm Password"
              name="confirm"
              outline />
          </v-flex>

          <v-flex xs12>
            <BaseButton
              :disabled="submitButtonDisabled"
              :hg-label="submitButtonLabel"
              type="submit" />
          </v-flex>
        </v-layout>
      </form>
    </v-container>
  </CardContainer>
</template>

<script>
import { Components, Constants, Mixins } from '@spectorasoftware/homegauge-vue';

import CardContainer from '@/components/CardContainer.vue';
import CardTitle from '@/components/CardTitle.vue';

const {
  BaseAlert,
  BaseButton,
  PasswordField,
  PasswordValidationField,
} = Components;
const { InputValidations } = Constants;
const { FormValidationsMixin } = Mixins;

const DEFAULT_PROP = {
  type: String,
  default: '',
};

export default {
  $_veeValidate: {
    validator: 'new',
  },
  components: {
    BaseAlert,
    BaseButton,
    CardContainer,
    CardTitle,
    PasswordField,
    PasswordValidationField,
  },
  props: {
    token: DEFAULT_PROP,
    personId: DEFAULT_PROP,
  },
  data() {
    return {
      error: null,
      loading: false,
      password: '',
      passwordConfirmation: '',
      inputValidations: InputValidations,
    };
  },
  mixins: [FormValidationsMixin],
  provide() {
    return {
      $validator: this.$validator,
    };
  },
  computed: {
    hasApiError() {
      return !!(this.error);
    },
    submitButtonDisabled() {
      return !this.formRequiredFieldsAreValid || this.loading;
    },
    submitButtonLabel() {
      return this.loading ? 'Saving Your Password' : 'Set New Password';
    },
  },
  methods: {
    clearApiErrors() {
      this.error = null;
    },
    clearFormErrors() {
      this.errors.clear();
    },
    onSubmit() {
      if (this.loading) {
        return;
      }

      this.loading = true;
      this.clearApiErrors();
      const payload = {
        password: this.password,
        personId: this.personId,
        token: this.token,
      };
      this.$store.dispatch('Person/updatePassword', payload)
        .then(() => {
          this.loading = false;
          this.redirectToLogin();
        })
        .catch(err => {
          this.loading = false;
          this.error = err;
        });
    },
    redirectToLogin() {
      this.$router.push({ path: '/', query: { passwordReset: 'true' } });
    },
  },
};
</script>
